import React from 'react';
import { connect } from '@gasbuddy/react';
import ForgotPasswordForm from './forgot-password-form';
import sharedStyle from '../../styles/shared.css';
import LoggedOutLayout from '../../components/logged-out-layout';
import FormMessage from '../../components/form-message';

/* eslint-disable react/prefer-stateless-function */
class ForgotPassword extends React.Component {
  render() {
    return (
      <LoggedOutLayout>
        <div className={sharedStyle.textCenter}>
          <FormMessage
            title="Request a Password Reset"
            subTitle={'Tell us the email address associated with your GasBuddy Business Pages account and '
              + 'we\'ll send you a link that will let you reset your password.'}
          />
          <ForgotPasswordForm />
        </div>
      </LoggedOutLayout>
    );
  }
}

export default connect()(ForgotPassword);
